// ─── Selector config ────────────────────────────────────────────────────────
// All DOM selectors in one place. Update here when class names change.
var SELECTORS = {
  // Price containers
  priceContainer:       "#product-info-price-container",
  salePrice:            "sale-price",
  compareAtPrice:       "compare-at-price",

  // Base product
  productInfo:          ".product-info",
  upsellCustomPrice:    ".product-info--fa:has(.pa-container-info.active):has(.upsell-enabled-text) .upsell-custom-price",
  flashDealPrice:       ".flash-deal-price-text",
  bundleToggleActive:   ".label-container-v2.active",

  // Upgrades / add-ons
  upgradeContainer:     ".upgrade-container",
  upgradeActive:        ".upgrade-container.active",
  upgradeRegularPrice:  ".pa-container-price-regular",
  upgradeComparePrice:  ".pa-container-price-compare",
  upgradeToggleInput:   ".pa-container-info-toggle input",
  specialDiscount:      "[data-special-discount-value]",

  // Popular addon
  popularAddonCheckbox: "#PopularAddonCheckbox",
  popularAddonInfo:     ".pa-container-info",
  popularAddonCallout:  ".pa-container-info--outer-callout",

  // Buy button
  buyButtons:           ".product-info__buy-buttons",
  // `.js-atc-label` is a stable hook that survives the label's type utility
  // being swapped for an NF preset class — `snippets/button.liquid` emits the
  // preset INSTEAD of `.text-button`, so hooking `.text-button` broke this
  // rewrite the moment a template picked a preset. `.text-button` is kept as a
  // fallback for callers that do not pass the hook.
  buyButtonText:        "span.button-text.js-atc-label, span.button-text.text-button",
  stickyBar:            ".product-quick-add",

  // Free gifts
  freeGifts:            ".ns-pdp-free-gifts__gift",
  freeGiftsActive:      ".ns-pdp-free-gifts__gift:not(.purchase-required):not(.inactive)",
  freeGiftPrice:        ".ns-pdp-free-gifts__gift-price>span.gift-price",
  freeGiftsWrapper:     ".ns-pdp-free-gifts__wrapper",
  freeGiftsCount:       "span.ns-pdp-free-gifts__header-gift-count",
  freeGiftsOrigPrice:   "span.ns-pdp-free-gifts__original-price",
  freeGiftInactive:     ".ns-pdp-free-gifts__gift.inactive",

  // Upsell (required-product link)
  activeUpsellProduct:  ".new_upsell_pa-container.upgrade-container.active",

  // Savings banner
  upgradeCheckboxes:    '.product .new_upsell_container input[type="checkbox"]',
  savingsWrapper:       ".product .new_upsell_container .new-upgrades-container__savings-wrapper",
  savingsText:          ".product .new_upsell_container .savings-text",
  savingsInnerWrapper:  ".upsell-upgrades-inner-wrapper",
  upsellErrorMessage:   "[data-upsell-error-message]",

  // Add-on price element, rendered by every ns-new-upsell version (v1–v6)
  addonPrice:           ".pa-container-info-details-price"

  // NOTE: observeTargets used to live here, holding
  // "#product-info-price-container sale-price" and ".pa-container-info-details-price".
  // Both now have dedicated ancestor-level observers further down — see
  // "Price normalization" and "Add-on price observer".
};

// Attribute holding the machine-readable price on <sale-price>/<compare-at-price>.
var PRICE_ATTR = "data-price-value";

// ─── Utilities ───────────────────────────────────────────────────────────────

var parseMoneyString = window.parseShopMoneyAmountString || function () { return NaN; };
function parseCurrencyText(element) {
  return typeof window.parseShopPriceFromElement === 'function'
    ? window.parseShopPriceFromElement(element)
    : 0;
}

// ─── Price normalization (Intelligems) ───────────────────────────────────────

// Intelligems price tests rewrite the RENDERED TEXT of <sale-price> but leave
// data-price-value at the price Liquid rendered, so the attribute goes stale
// mid-test. window.parseShopPriceFromElement prefers the attribute, and
// ns-new-upsell.liquid / ns-new-upsell-v2.liquid read it raw with no text
// fallback at all. Rather than change that shared parser, we reconcile the
// attribute from the rendered text at the source, so every consumer reads a
// correct value without being touched.

// Count of data-price-value writes WE made that have not yet echoed back through
// the observer. A plain boolean set around setAttribute would not work here:
// MutationObserver callbacks are delivered asynchronously, so the flag is always
// back to false by the time the callback runs and would suppress nothing.
var _pendingSelfWrites = 0;

// The one container the price observer below is bound to.
//
// snippets/product-info.liquid emits id="product-info-price-container" TWICE
// (the desktop `price` block and the mobile `price_mob` block), and Intelligems
// renders up to nine .product-info copies, so a live PDP carries many elements
// sharing this id. Only writes inside the OBSERVED copy echo back through the
// observer, so only those may increment _pendingSelfWrites — counting a write
// to any other copy would leave a permanently unconsumed increment and the
// counter would start swallowing genuine external price changes.
var _observedPriceContainer = document.querySelector(SELECTORS.priceContainer);

/**
 * Reconciles one price element's data-price-value with its rendered text.
 *
 * Writes only when the parsed text is a usable amount AND differs from the
 * current attribute. Idempotent by design — that is what stops our own write
 * from feeding back through the observer into an endless recalculation loop.
 *
 * Refuses to write a non-positive or unparseable amount. The attribute is the
 * source of truth for the upsell snippets, so a transient skeleton value during
 * a variant swap must never be persisted.
 *
 * @param {Element} element   the <sale-price>/<compare-at-price> to reconcile
 * @param {boolean} countEcho  true only when the element sits inside the
 *                             observed container, so the write's echo can be
 *                             consumed by the observer callback
 * @returns {boolean} true if the attribute was changed
 */
function normalizePriceElement(element, countEcho) {
  if (!element) return false;

  var renderedPrice = parseMoneyString(element.textContent || '');
  if (!isFinite(renderedPrice) || renderedPrice <= 0) return false;

  var attributePrice = parseMoneyString(element.getAttribute(PRICE_ATTR));
  if (!isNaN(attributePrice) && Math.abs(attributePrice - renderedPrice) < 0.005) return false;

  if (countEcho) _pendingSelfWrites++;
  element.setAttribute(PRICE_ATTR, renderedPrice.toFixed(2));
  return true;
}

/**
 * Reconciles both price elements inside EVERY PDP price container.
 *
 * querySelector would return only the first element carrying the duplicated
 * id — which is inside a hidden copy — leaving the visible one with a stale
 * data-price-value. Consumers all resolve that same first match, so this does
 * not change which element anyone reads; it just stops the other copies from
 * carrying a wrong attribute.
 *
 * Safe to call repeatedly — normalizePriceElement is a no-op when in sync.
 */
function normalizePriceContainer() {
  var containers = document.querySelectorAll(SELECTORS.priceContainer);
  for (var i = 0; i < containers.length; i++) {
    var container = containers[i];
    var countEcho = container === _observedPriceContainer;
    normalizePriceElement(container.querySelector(SELECTORS.salePrice), countEcho);
    normalizePriceElement(container.querySelector(SELECTORS.compareAtPrice), countEcho);
  }
}

// ─── Dynamic price calculation ───────────────────────────────────────────────

/**
 * Calculates the total price shown on the PDP buy button.
 * Combines: base product price (or upsell/flash deal override)
 *         + active upgrade add-on prices
 *         + free gift prices (compare-at only)
 *         - special discount (from data attribute)
 * Then renders the result into the buy button, sticky bar, and
 * dispatches "pdp-cta:update" for freebies snippets to react to.
 */
function calculateDynamicPrice(hasToggleBundle) {
  let productInfoContainer = document.querySelector(SELECTORS.productInfo);
  let priceInfoContainer = document.querySelector(SELECTORS.priceContainer);

  // Determine base price: upsell price > flash deal price > regular sale price
  let upsellPriceEl = document.querySelector(SELECTORS.upsellCustomPrice);
  let flashDealPriceEl = document.querySelector(SELECTORS.flashDealPrice);
  let productPriceEl = priceInfoContainer.querySelector(SELECTORS.salePrice);

  let productPrice;
  if (upsellPriceEl) {
    productPrice = parseCurrencyText(upsellPriceEl);
  } else if (flashDealPriceEl) {
    productPrice = parseCurrencyText(flashDealPriceEl);
  } else {
    productPrice = parseCurrencyText(productPriceEl);
  }

  // Override price source if a bundle toggle is active
  if (hasToggleBundle === true) {
    const togglePriceEl = productInfoContainer.querySelector(SELECTORS.bundleToggleActive);
    if (togglePriceEl) {
      productPriceEl = togglePriceEl;
    }
  }

  // Get base compare-at price; fall back to sale price if none exists
  let productComparePrice = parseCurrencyText(priceInfoContainer.querySelector(SELECTORS.compareAtPrice));
  let newPrice = productPrice;
  let newComparePrice = productComparePrice || productPrice;

  // Sum prices from all active upgrade add-ons
  document.querySelectorAll(SELECTORS.upgradeActive).forEach((el) => {
    let regularPriceEl = el.querySelector(SELECTORS.upgradeRegularPrice);
    let comparePriceEl = el.querySelector(SELECTORS.upgradeComparePrice) || regularPriceEl;
    let upgRegular = parseCurrencyText(regularPriceEl);
    let upgCompare = parseCurrencyText(comparePriceEl);
    newPrice += upgRegular;
    newComparePrice += upgCompare;
  });

  // Check spend limits and update .inactive on each free gift.
  // Uses newPrice (sale + upgrades) directly — no buy button roundtrip needed.
  document.querySelectorAll(SELECTORS.freeGifts).forEach(gift => {
    const rawLimit = gift.getAttribute('data-spend-limit');
    const spendLimit = parseMoneyString(rawLimit);
    if (!isNaN(spendLimit)) {
      if (newPrice >= spendLimit) {
        gift.classList.remove('inactive');
      } else {
        gift.classList.add('inactive');
      }
    }
  });

  // Add free gift values to compare-at price (strikethrough total).
  // .inactive is now correct so this is accurate on the first pass.
  document.querySelectorAll(SELECTORS.freeGiftsActive + " " + SELECTORS.freeGiftPrice).forEach((el) => {
    let giftValue = parseCurrencyText(el);
    newComparePrice += giftValue;
  });

  // Apply special discount from data attribute on the first upgrade price element
  let discountElement = document.querySelector(SELECTORS.upgradeRegularPrice);
  if (discountElement) {
    const discountAttributeValue = discountElement.getAttribute("data-special-discount-value");
    if (discountAttributeValue !== null) {
      const specialDiscountValue = parseMoneyString(discountAttributeValue);
      if (!isNaN(specialDiscountValue) && specialDiscountValue > 0) {
        newPrice -= specialDiscountValue;
      }
    }
  }

  // Format final prices using the theme's money formatter (shop.money_format placeholders vary by currency)
  var fmtMoney = typeof window.themeFormatMoneyMajorUnits === 'function'
    ? window.themeFormatMoneyMajorUnits
    : function (n) {
        return String(n);
      };
  let newPriceText = fmtMoney(newPrice);
  let newComparePriceText = fmtMoney(newComparePrice);
  if (newPriceText === newComparePriceText || newComparePriceText === "$0") {
    newComparePriceText = "";
  }

  // Update buy button text
  const buyButton = document.querySelector(SELECTORS.buyButtons);
  const buttonTextSpan = buyButton.querySelector(SELECTORS.buyButtonText);
  let buttonLabel = buttonTextSpan.textContent.trim();
  if (buttonLabel.includes("-")) {
    buttonLabel = buttonLabel.slice(0, buttonLabel.indexOf("-")).trim();
  }
  buttonTextSpan.innerHTML = `${buttonLabel} <span class="dash">-</span> <span class="button-text-price"><span class="button-text-comparePrice">${newComparePriceText}</span><span class="button-text-salePrice">${newPriceText}</span></span>`;

  // Update sticky buy bar
  let stickyBar = document.querySelector(SELECTORS.stickyBar);
  if (stickyBar) {
    let stickyBarSalePrice = stickyBar.querySelector(SELECTORS.salePrice);
    let stickyBarComparePrice = stickyBar.querySelector(SELECTORS.compareAtPrice);
    if (stickyBarSalePrice) stickyBarSalePrice.innerHTML = newPriceText;
    if (stickyBarComparePrice) stickyBarComparePrice.innerHTML = newComparePriceText;
  }

  // Notify freebies/upsell snippets that the price has been recalculated.
  // Pass newPrice in detail so listeners never need to re-parse the buy button.
  document.dispatchEvent(new CustomEvent("pdp-cta:update", { bubbles: true, detail: { price: newPrice } }));
}

/**
 * Schedules a calculateDynamicPrice call after a short delay.
 * Used by toggle/interaction handlers to let the Shopify theme
 * finish updating price elements in the DOM before we read them.
 * Debounced so rapid toggles only trigger one recalculation.
 */
var _recalcTimer = null;
function scheduleRecalculation(hasToggleBundle) {
  if (_recalcTimer) clearTimeout(_recalcTimer);
  _recalcTimer = setTimeout(function () {
    _recalcTimer = null;
    calculateDynamicPrice(hasToggleBundle);
  }, 50);
}

// ─── Freebies ────────────────────────────────────────────────────────────────

/**
 * Updates the freebies banner price display.
 * Reads active gift totals from data-amount attributes and updates
 * the ns-pdp-free-gifts__original-price span, then calls updateHeaderPrice()
 * which is defined in the freebies Liquid snippet (global).
 *
 * Runs at 100ms so the buy button is fully rendered before updateHeaderPrice
 * reads it to build the banner subheader text.
 */
var _freebiesTimer = null;
function updateFreebiesComparePrice() {
  if (_freebiesTimer) clearTimeout(_freebiesTimer);
  _freebiesTimer = setTimeout(function () {
    _freebiesTimer = null;
    let totalAmount = 0;
    document.querySelectorAll(SELECTORS.freeGiftsActive).forEach(gift => {
      const amount = parseFloat(gift.getAttribute('data-amount'));
      if (!isNaN(amount)) totalAmount += amount;
    });

    const priceSpan = document.querySelector(SELECTORS.freeGiftsOrigPrice);
    if (priceSpan) priceSpan.textContent = "$" + totalAmount.toFixed(2);

    // Guarded because this global is defined by the freebies snippet, and not
    // every free-gifts version defines it — pdp-free-gifts and -v9 do not. This
    // script loads unconditionally on every fa-main-product section, so calling
    // it bare threw a ReferenceError on those templates and killed the rest of
    // this callback. Mirrors how parseShopPriceFromElement is guarded above.
    if (typeof window.updateHeaderPrice === 'function') {
      window.updateHeaderPrice();
    }
  }, 100);
}

/**
 * Checks each free gift to see if its required upsell product is active.
 * Marks gifts as "purchase-required" if their linked upsell isn't selected,
 * then updates the freebies wrapper to reflect completion status (e.g. "2/3").
 */
function checkForRequiredProduct() {
  var reqProductCounter = 0;
  const giftItems = document.querySelectorAll(SELECTORS.freeGifts);
  const activeUpsell = document.querySelector(SELECTORS.activeUpsellProduct);

  giftItems.forEach(function (gift) {
    if (gift.getAttribute("data-required-product-id") == null) return;

    if (activeUpsell && activeUpsell.getAttribute("data-product-id") === gift.getAttribute("data-required-product-id")) {
      gift.classList.remove('purchase-required');
      updateFreebiesWrapper(true, giftItems.length);
    } else {
      gift.classList.add('purchase-required');
      reqProductCounter++;
      updateFreebiesWrapper(false, giftItems.length, reqProductCounter);
    }
  });

  const inactiveCount = document.querySelectorAll(SELECTORS.freeGiftInactive).length;
  if (inactiveCount) {
    updateFreebiesWrapper(false, giftItems.length, inactiveCount);
  } else {
    updateFreebiesWrapper(true, giftItems.length, 0);
  }
}

/**
 * Updates the freebies wrapper UI: toggles the "incomplete" class
 * and sets the gift count display (e.g. "2/3").
 * Called externally by pdp-freebies-banner-with-popup.liquid.
 */
function updateFreebiesWrapper(isComplete, giftsCount, counter) {
  const giftWrapper = document.querySelector(SELECTORS.freeGiftsWrapper);
  const giftCountEL = document.querySelector(SELECTORS.freeGiftsCount);
  if (!giftWrapper || !giftCountEL) return;

  // Flash deal reads "FLASH DEAL: 2 GIFTS UNLOCKED", so the count element holds
  // a bare number there rather than the X/Y fraction the other freebies surfaces
  // use. .flash-deal-gift-count is only ever emitted in flash mode, so this
  // leaves every non-flash surface on the fraction exactly as before.
  const isFlashDeal = giftCountEL.classList.contains('flash-deal-gift-count');

  if (isComplete) {
    giftWrapper.classList.remove('incomplete');
    giftCountEL.innerHTML = isFlashDeal ? String(giftsCount) : giftsCount + "/" + giftsCount;
  } else {
    giftWrapper.classList.add('incomplete');
    const unlocked = giftsCount - counter;
    giftCountEL.innerHTML = isFlashDeal ? String(unlocked) : unlocked + "/" + giftsCount;
  }
}

checkForRequiredProduct();

// ─── Upgrades savings ────────────────────────────────────────────────────────

var _totalSavingPriceValue = 0;

// Sums data-save-price from all active+checked upgrades
function calculateUpgradesSavings() {
  let totalSavePrice = 0;
  document.querySelectorAll(SELECTORS.upgradeActive).forEach((container) => {
    let checkbox = container.querySelector('input');
    let savePriceEl = container.querySelector('[data-save-price]');
    if (checkbox.checked && savePriceEl) {
      totalSavePrice += +savePriceEl.getAttribute('data-save-price');
    }
  });
  _totalSavingPriceValue = Math.floor(totalSavePrice);
  updateSavingText();
}

// Returns true if any upgrade inside the wrapper is active
function hasActiveUpgrade() {
  const wrapper = document.querySelector(SELECTORS.savingsInnerWrapper);
  if (!wrapper) return false;
  return wrapper.querySelector('.active') !== null;
}

// Updates the "You're saving $X" banner or shows the error message
function updateSavingText() {
  const ugradeSavingWrapperEl = document.querySelector(SELECTORS.savingsWrapper);
  const ugradeSavingTextEl = document.querySelector(SELECTORS.savingsText);
  const hasUpgrade = hasActiveUpgrade();

  const noUpgradesErrorMessageEl = document.querySelector(SELECTORS.upsellErrorMessage);
  const noUpgradesErrorMessage = noUpgradesErrorMessageEl
    ? noUpgradesErrorMessageEl.getAttribute('data-upsell-error-message')
    : '';

  if (hasUpgrade) {
    if (ugradeSavingWrapperEl) {
      ugradeSavingWrapperEl.classList.add('savings');
      ugradeSavingWrapperEl.classList.remove('no-savings', 'no-upgrades');
    }
    if (ugradeSavingTextEl) {
      ugradeSavingTextEl.textContent = `You're saving $${_totalSavingPriceValue}`;
    }
  } else {
    if (ugradeSavingWrapperEl) {
      ugradeSavingWrapperEl.classList.remove('savings');
      ugradeSavingWrapperEl.classList.add('no-savings', 'no-upgrades');
    }
    if (ugradeSavingTextEl) {
      ugradeSavingTextEl.textContent = noUpgradesErrorMessage;
    }
  }
}

// ─── Upgrades init ───────────────────────────────────────────────────────────

/**
 * Initializes all upgrade/upsell UI:
 * - Marks pre-checked upgrades as active
 * - Binds the popular addon checkbox toggle (with animation classes)
 * - Binds individual upgrade toggle inputs
 * - Runs initial savings calculation
 * - Schedules the first calculateDynamicPrice() call
 */
function upgradesInit() {
  let upgradeContainerEls = document.querySelectorAll(SELECTORS.upgradeContainer);

  // `.active` is DERIVED from the input on load, never assumed from the server
  // render. A soft reload restores checkbox state without re-running the Liquid
  // that painted `.active`, so the two desync: the pill goes purple off
  // `input:checked` while the knob, the checkmark, the card and the prices all
  // stay in the off state — and the next click then toggles `.active` ON while
  // unchecking the input, which is the grey-pill-with-a-checkmark render.
  upgradeContainerEls.forEach((el) => {
    checkForRequiredProduct();
    const toggleInput = el.querySelector(SELECTORS.upgradeToggleInput);
    el.classList.toggle("active", Boolean(toggleInput && toggleInput.checked));
    if (toggleInput && toggleInput.checked) {
      updateFreebiesComparePrice();
    }
  });

  // Popular addon toggle
  let popularAddonCheckbox = document.querySelector(SELECTORS.popularAddonCheckbox);
  let popularAddonInfoBox = document.querySelector(SELECTORS.popularAddonInfo);
  let calloutBox = document.querySelector(SELECTORS.popularAddonCallout);

  // Same derivation for the popular addon card — see the comment above.
  if (popularAddonCheckbox && popularAddonInfoBox) {
    popularAddonInfoBox.classList.toggle("active", popularAddonCheckbox.checked);
  }

  if (popularAddonCheckbox) {
    popularAddonCheckbox.addEventListener("input", () => {
      if (popularAddonInfoBox) {
        calloutBox?.classList.add('unbounce');
        popularAddonInfoBox.classList.toggle("active", popularAddonCheckbox.checked);

        if (popularAddonInfoBox.classList.contains("active")) {
          popularAddonInfoBox.classList.add("just-enabled");
        } else {
          popularAddonInfoBox.classList.add("just-disabled");
          calloutBox?.classList.remove('unbounce');
        }

        // Remove animation classes after transition
        setTimeout(function () {
          popularAddonInfoBox.classList.remove("just-enabled", "just-disabled");
        }, 1000);
      }

      checkForRequiredProduct();
      updateFreebiesComparePrice();
      scheduleRecalculation();
    });
  }

  // Individual upgrade toggle inputs
  upgradeContainerEls.forEach((el) => {
    const toggleInput = el.querySelector(SELECTORS.upgradeToggleInput);
    toggleInput?.addEventListener("input", () => {
      el.classList.toggle("active", toggleInput.checked);
      checkForRequiredProduct();
      updateFreebiesComparePrice();
      scheduleRecalculation();
    });
  });

  // Savings banner — re-calculate on any upgrade checkbox change
  let allUpgradeCheckboxes = document.querySelectorAll(SELECTORS.upgradeCheckboxes);
  let ugradeSavingWrapperEl = document.querySelector(SELECTORS.savingsWrapper);
  allUpgradeCheckboxes.forEach(el => el.addEventListener('input', () => {
    calculateUpgradesSavings();
    if (!el.checked && ugradeSavingWrapperEl) {
      ugradeSavingWrapperEl.classList.remove("savings");
      setTimeout(() => ugradeSavingWrapperEl.classList.add("savings"), 1000);
    }
  }));

  calculateUpgradesSavings();
  scheduleRecalculation();
}

upgradesInit();

// ─── MutationObservers ───────────────────────────────────────────────────────

// Reconcile the price attribute BEFORE the first calculation, so the buy button
// and the upsell snippets both start from the rendered price rather than a stale
// Liquid one.
normalizePriceContainer();

// Watch for external price changes (e.g. Shopify variant switches)
// and re-run calculateDynamicPrice when detected
calculateDynamicPrice(true);

/**
 * Watches the price CONTAINER, not the <sale-price> node itself.
 *
 * The container is stable for the life of the page; the price elements are not.
 * Intelligems and Shopify variant re-renders both REPLACE those nodes, which
 * strands an observer bound to the original — it stays alive but attached to a
 * detached node and never fires again. Observing the container survives that,
 * and also covers the case where the price element has not rendered yet when
 * this script runs.
 *
 * Attribute mutations are included because Intelligems signals its price test by
 * rewriting classes and attributes as well as text.
 */
var priceContainerEl = _observedPriceContainer;
if (priceContainerEl) {
  const priceObserver = new MutationObserver((mutationsList) => {
    let hasExternalChange = false;

    for (const mutation of mutationsList) {
      // Consume the echo of our own normalization write rather than treating it
      // as an external price change. One consumed mutation per write we made.
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === PRICE_ATTR &&
        _pendingSelfWrites > 0
      ) {
        _pendingSelfWrites--;
        continue;
      }
      hasExternalChange = true;
    }

    if (!hasExternalChange) return;

    // Normalize first so the recalculation reads a reconciled attribute.
    normalizePriceContainer();
    // Debounced so this can't race with a toggle's .active class being set.
    scheduleRecalculation(true);
  });

  priceObserver.observe(priceContainerEl, {
    characterData: true,
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [PRICE_ATTR, 'class']
  });
}

// ─── Add-on price observer ───────────────────────────────────────────────────

/**
 * Returns true if a mutation actually touches an add-on price element.
 *
 * The add-on observer watches a broad subtree, so this filter is what keeps it
 * from scheduling a recalculation on every unrelated DOM change inside the
 * product info panel.
 */
function touchesAddonPrice(mutation) {
  const selector = SELECTORS.addonPrice;

  // A text edit inside an existing price element. characterData targets are
  // text nodes, which have no .closest() of their own.
  if (mutation.type === 'characterData') {
    const parent = mutation.target.parentElement;
    return !!(parent && parent.closest(selector));
  }

  if (mutation.type !== 'childList') return false;

  // The mutation landed inside a price element.
  const target = mutation.target;
  if (target && typeof target.closest === 'function' && target.closest(selector)) return true;

  // Or it added a subtree CONTAINING one. An upsell block re-rendering replaces
  // the price element wholesale rather than editing its text, so the mutation
  // target is the container above it, not the price element itself.
  for (const node of mutation.addedNodes) {
    if (node.nodeType !== Node.ELEMENT_NODE) continue;
    if (node.matches(selector) || node.querySelector(selector)) return true;
  }

  return false;
}

/**
 * Watches add-on prices through a STABLE ANCESTOR rather than the price nodes.
 *
 * The previous implementation called document.querySelector on the add-on price
 * class and observed that single node. Two problems. The class is rendered by
 * all six ns-new-upsell versions, so only whichever appeared first in the DOM
 * was ever watched. And the node is replaced whenever an upsell re-renders,
 * which left the observer bound to a detached element where it silently never
 * fired again.
 *
 * .product-info (snippets/product-info.liquid:147) is the wrapper every upsell
 * variant is dispatched from, so it is stable for the life of the page, covers
 * all six versions at once, and catches variants that render late.
 */
const addonHostEl = document.querySelector(SELECTORS.productInfo);
if (addonHostEl) {
  const addonObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (!touchesAddonPrice(mutation)) continue;
      // Debounced so this can't race with a toggle's .active class being set.
      scheduleRecalculation(true);
      break;
    }
  });

  addonObserver.observe(addonHostEl, {
    characterData: true,
    childList: true,
    subtree: true
  });
}
